class ButtonToggle {
  constructor () {
    this.toggle = document.querySelectorAll('.time-button');
    this.submitButton = document.querySelector('.form-submit-button');
    this.setInitialTime();
    this.init();
  }

  init() {
    if(this.toggle) {
      this.toggle.forEach(button => {
        button.addEventListener('click', () => {
          // Remove 'active' class from all buttons
          this.toggle.forEach(btn => btn.classList.remove('active'));

          // Add 'active' class to the clicked button
          button.classList.add('active');

          // Update submit button's data-time attribute
          const selectedTime = button.getAttribute('data-time');
          this.submitButton.setAttribute('data-time', selectedTime);
        });
      });
    }
  }

  setInitialTime() {
    // Find the button that is active by default
    const activeButton = document.querySelector('.time-button.active');
    if (activeButton) {
      const time = activeButton.getAttribute('data-time');
      this.submitButton.setAttribute('data-time', time);
    }
  }
}

const buttonToggle = new ButtonToggle();

// class FormCheckbox {
//   constructor() {
//     this.checkbox = document.querySelector('.checkbox-content');
//     this.formButton = document.querySelector('.form-submit-button')
//     this.init();
//   }

//   init() {
//     if(this.checkbox) {
//       this.checkbox.addEventListener('click', () =>{
//         this.checkbox.classList.toggle('disabled')
//         this.formButton.classList.toggle('disabled')
//       })
//     }
//   }
// }

// const formCheckbox = new FormCheckbox();

class FormSubmitButton {
  constructor() {
    this.form = document.querySelector('.form-type--form-inner');
    this.button = document.querySelector('.form-submit-button');
    this.popup = document.querySelector('.form-type--popup-video');
    this.firstNameInput = document.querySelector('#firstName');
    this.lastNameInput = document.querySelector('#lastName');
    this.emailInput = document.querySelector('#email');
    this.popupItems = document.querySelectorAll('.popup-item');

    if (this.button) {
      this.init();
    }
  }

  init() {
    this.button.addEventListener('click', async (e) => {
      e.preventDefault();

      // Disable form & show popup video right away
      this.form?.classList.add('disabled');
      this.popup?.classList.remove('disabled');

      const firstName = this.firstNameInput?.value.trim();
      const lastName = this.lastNameInput?.value.trim();
      const email = this.emailInput?.value.trim();
      const store = this.button.dataset.storeid;
      const campaignId = this.button.dataset.campaignid;

      if (!firstName || !lastName || !email) {
        alert('Please fill in all required fields.');
        this.form?.classList.remove('disabled');
        this.popup?.classList.add('disabled');
        return;
      }

      try {
        const response = await fetch('https://el-ecommerce-admin-7936c3452dfc.herokuapp.com/app/endpoint/instant/win', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            firstName,
            lastName,
            email,
            store,
            campaignId
          }),
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const result = await response.json();
        const prize = result.prize;
        const prizeType = prize?.type;
        const prizeValue = prize?.value;

        console.log('Prize object:', prize);

        this.popup?.classList.add('disabled');

        const rewardItem = document.querySelector(`.popup-item[data-reward="${prizeType}"]`);
        if (rewardItem) {
          rewardItem.classList.remove('disabled');

          // Free Pouch
          if (prizeType === 'free_pouch') {
            const pouchSpan = rewardItem.querySelector('.pouch-pack');
            if (pouchSpan) {
              pouchSpan.textContent = `${prizeValue} FREE ${prizeValue === '1' ? 'Can' : 'Cans'}`;
            }

          // Discount Code
          } else if (prizeType === 'discount_code') {
            const discountSpan = rewardItem.querySelector('.discount-text');
            const voucherCodeSpan = rewardItem.querySelector('.voucher-code');
            const discountCodesAttr = rewardItem.dataset.discountcode;

            if (discountSpan) {
              discountSpan.textContent = `${prizeValue}% Off`;
            }

            if (voucherCodeSpan && discountCodesAttr) {
              const discountCodes = discountCodesAttr.split(',').map(code => code.trim());

              const matchingCode = discountCodes.find(code => code.endsWith(prizeValue));

              if (matchingCode) {
                voucherCodeSpan.textContent = matchingCode;
              } else {
                console.warn(`No discount code ends with: ${prizeValue}`);
              }
            }

          // Store Credit
          } else if (prizeType === 'store_credit') {
            const creditSpan = rewardItem.querySelector('.credit-amount');
            if (creditSpan) {
              creditSpan.textContent = `£${prizeValue}`;
            }
          }
        }

      } catch (error) {
        console.error('Error submitting form:', error.message);

        this.popup?.classList.add('disabled');

        const errorBlock = document.querySelector('.form-type--error-image');
        errorBlock?.classList.remove('disabled');

        setTimeout(() => {
          errorBlock?.classList.add('disabled');
          this.form?.classList.remove('disabled');
        }, 3000);
      }
    });
  }
}


const formSubmitButton = new FormSubmitButton